/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Notifications_Task_Completed_TitleInputs */

const en_notifications_task_completed_title = /** @type {(inputs: Notifications_Task_Completed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Task completed: ${i?.task}`)
};

const pt_br2_notifications_task_completed_title = /** @type {(inputs: Notifications_Task_Completed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atividade concluída: ${i?.task}`)
};

/**
* | output |
* | --- |
* | "Task completed: {task}" |
*
* @param {Notifications_Task_Completed_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_completed_title = /** @type {((inputs: Notifications_Task_Completed_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Completed_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_completed_title(inputs)
	return pt_br2_notifications_task_completed_title(inputs)
});